import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";
import PourquoiPacte from "../sections/PourquoiPacte";
import Partenaires from "../sections/Partenaires";
import CommentCaMarche from "../sections/CommentCaMarche";
import AvisCarousel from "../sections/AvisCarousel";
import CommercantsCTA from "../sections/CommercantsCTA";
import FAQ from "../sections/FAQ";
import MarqueeTags from "../sections/MarqueeTags";
import videoMotion from '../videos/Pacte_-_Sequence_2__Motion_Sound.mp4'

import bgHero from "../images/bg-hero.png";
import homescreentest from "../images/home-page-test.png";
import DownloadApple from "../images/download-apple.png";
import DownloadAndroid from "../images/download-android.png";


export default function LandingPage() {
  return (
    <div className="relative min-h-screen text-black overflow-hidden bg-white">
      <NavBar />
      <section className="mx-auto max-w-[1519px] px-4 sm:px-6 lg:px-8 mt-6">
        <div className="relative overflow rounded-3xl shadow-lg">
          <div
            aria-hidden
            className="absolute inset-0 rounded-3xl bg-gradient-to-t from-[#E35EA7] to-[#FFDDEA]"
          />
          <div
            aria-hidden
            className="absolute inset-0 rounded-3xl bg-center bg-cover opacity-60"
            style={{ backgroundImage: `url(${bgHero})` }}
          />

          <div
            className="
              relative grid grid-cols-1
              md:grid-cols-[30%_70%]
              items-center gap-6 lg:gap-10
              p-5 sm:p-8 lg:p-12
              min-h-[620px] lg:min-h-[840px]
            "
          >
            <div className="order-2 md:order-1 relative flex flex-col items-center md:items-start justify-start">
              <img
                src={homescreentest}
                alt="Aperçu application PACTE"
                className="
                  relative z-10
                  w-[78%] max-w-[380px]
                  md:w-[140%] md:max-w-[660px]
                  md:-mt-12 md:-ml-48
                  sm:w-[90%] sm:max-w-[420px] 
                  drop-shadow-2xl
                "
              />
              <p className=" text-white/90 text-xl sm:mt-6 md:ml-6 -mt-8">
                Télécharger dès maintenant :
              </p>
              <div className="mt-3 flex items-center gap-3 md:ml-6">
                <a target="_blank" href="https://apps.apple.com/app/id6746101122"><img src={DownloadApple} alt="Télécharger dans l'App Store" className="h-14 w-auto" /></a>
                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.claix.pacteclaixapp&pcampaignid=web_share"><img src={DownloadAndroid} alt="Télécharger dans le Play Store" className="h-14 w-auto" /></a>
              </div>
            </div>

            <div className="order-1 md:order-2 flex flex-col justify-center text-white md:pl-6">
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-asap font-[500] leading-tight max-w-[980px]">
                L’association des commerçants<br/>
                claixois pour dynamiser notre
                centre-ville.
              </h1>

              <p className="mt-4 text-white/90 text-sm sm:text-base max-w-[760px]">
               Le <b>PACTE (Promouvons nos Acteurs Claixois Tous Ensemble)</b> réunit les commerçants du centre-bourg et de Pont-Rouge autour d’une application unique. Explorez, soutenez et bénéficiez de récompenses en consommant local.
              </p>

              <div className="mt-6 flex flex-wrap items-center gap-4">
                <Link
                  to="https://www.helloasso.com/associations/promouvons-nos-acteurs-claixois-tous-ensemble/formulaires/1"
                  target="_blank"
                  className="inline-flex items-center justify-center rounded-full bg-black text-white
                             px-6 py-3 text-sm font-medium shadow-[0_10px_24px_rgba(0,0,0,0.35)]
                             hover:opacity-90 transition"
                >
                  Soutenir le projet
                </Link>
                <Link
                  to="/qui-sommes-nous"
                  className="inline-flex items-center justify-center rounded-full bg-white text-neutral-900
                            px-6 py-3 text-sm font-medium
                            s shadow-[0_4px_4px_rgba(0,0,0,0.25),_inset_0_0_10px_rgba(0,0,0,0.2)]
                            hover:bg-white/95 transition"
                >
                  Qui sommes-nous ?
                </Link>
              </div>
            </div>
          </div>

          <div aria-hidden className="pointer-events-none absolute inset-0 rounded-3xl ring-1 ring-white/30" />
        </div>
      </section>

      <PourquoiPacte />
      <Partenaires />
      <CommentCaMarche
        videoSrc={videoMotion}
        poster="/images/poster-demo.jpg"  
        audioSrc="/audio/extrait-radio.mp3"
      />
      <AvisCarousel />
      <CommercantsCTA />
      <FAQ />
      <MarqueeTags />
      <Footer />
    </div>
  );
}